import {Component} from 'preact';
import {client} from '@core/GraphQLProvider';
import Cookies from 'js-cookie';
import {Outlet} from 'react-router-dom';
import {ScrollToTopOfRoute} from '@components/common/ScrollToTop';
import dataLayer from '@upi/data-layer';
import appLogger from '@core/LoggingProvider';
import {$CONTENT_WINDOW} from '@config/selectors';
import {COOKIES} from '@util/StorageUtils';
import NewsletterService from '@services/NewsletterService';
import {anyEmptyOrNil, anyNotEmptyOrNil} from '@ultradent/utilities/EmptyOrNil';

const initialState = {
    dentalLicense: '',
    emailAddress: '',
    password: '',
    dentistFullName: '',
    specialty: 'General Practice',
    practiceName: '',
    officePhone: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    postalCode: '',
    offers: false,
    accountNumber: '',
    invoiceId: '',
    addresses: [],

    dentalLicenseExists: false,
    step: 1,
    viewCount: 1,
    county: false,

    signUpLoading: false,
    signUpSubmitting: false,
    signUpSuccess: false,
    signUpError: false
};

class RegistrationContainer extends Component {
    constructor ( props ) {
        super( props );
        this.state = initialState;

        this.handleChange = this.handleChange.bind( this );
        this.handleNewsletterSignup = this.handleNewsletterSignup.bind( this );

        this.handleRouteChange = this.handleRouteChange.bind( this );

        this.setUserAddresses = this.setUserAddresses.bind( this );
        this.setCounty = this.setCounty.bind( this );
        this.setStep = this.setStep.bind( this );
        this.setDentalLicense = this.setDentalLicense.bind( this );
        this.set_registration_status = this.set_registration_status.bind( this );

        this.registration_locked = this.registration_locked.bind( this );

        this.get_registration_status = this.get_registration_status.bind( this );
    }

    authorization ( location ) {
        const {state, props} = this;

        return {
            hasAccountDetails: () => {
                return !anyEmptyOrNil( [
                    state.dentistFullName,
                    state.dentalLicense,
                    state.emailAddress,
                    state.password
                ] );
            },
            hasEmailAddress: function () {
                return anyNotEmptyOrNil( [location.state?.emailAddress, state.emailAddress] );
            },
            hasAddress: function () {
                return state.addresses.length !== 0;
            },
            hasMultipleAddresses: function () {
                return state.addresses?.length > 1;
            }
        };
    }

    setCounty ( county ) {
        this.setState( {county} );
    }

    setStep ( step ) {
        this.setState( {step} );
    }

    resetForm () {
        this.setState( initialState );
    }

    setDentalLicense ( value ) {
        this.setState( {dentalLicenseExists: value} );
    }

    setUserAddresses ( addresses ) {
        this.setState( {addresses} );
    }

    handleChange = e => {
        this.setState( {[e.target.name]: e.target.value} );
    };

    handleNewsletterSignup ( emailAddress ) {
        this.setState( {signUpSubmitting: true, signUpLoading: true} );
        NewsletterService.subscribe( emailAddress )
            .then( resp => {
                dataLayer.forms.formSubmit( {
                    formName: 'Newsletter'
                } );
                this.setState( {
                    signUpSubmitting: false,
                    signUpLoading: false,
                    signUpSuccess: resp,
                    signUpError: false
                } );
            } )
            .catch( error => {
                appLogger.capture( error );
                this.setState( {
                    signUpSubmitting: false,
                    signUpLoading: false,
                    signUpSuccess: false,
                    signUpError: true
                } );
            } );
    }

    registration_locked () {
        return this.get_registration_status();
    }

    set_registration_status ( status ) {
        const locked = status && 'locked';
        this.setState( {step: locked} );
        Cookies.set( COOKIES.REGISTRATION.LOCKED.name, status, {expires: 1} );
    }

    get_registration_status () {
        return Cookies.get( COOKIES.REGISTRATION.LOCKED.name );
    }

    handleRouteChange = ( event ) => {
        const viewCount = this.state.viewCount + 1;
        const detail = {
            step: event.target.location.hash,
            viewCount
        };

        dataLayer.user.sendUserRegistrationProgress( detail );
        this.setState( {viewCount} );
    };

    componentDidMount ( e ) {
        this.scrollEl = document.querySelector( $CONTENT_WINDOW );

        // Set up native browser event listeners
        window.addEventListener( 'popstate', this.handleRouteChange );

        const detail = {
            step: '/',
            viewCount: this.state.viewCount
        };
        dataLayer.user.sendUserRegistrationProgress( detail );
    }

    render () {

        return (
            <div className="w-full md:max-w-sm mx-auto my-8 md:my-16">
                    <ScrollToTopOfRoute/>
                    <img className="block my-4 md:my-12 mx-auto h-auto w-24 md:w-32"
                         src="/svg/site-logos/upi-icon-color-tagline.svg"
                         alt="Ultradent Products Logo"/>
                        <Outlet context={{
                            isRegistrationLocked: () => this.registration_locked(),
                            authorization: this.authorization,
                            client: client,
                            state: this.state,
                            signUp: this.handleNewsletterSignup,
                            handleChange: this.handleChange,
                            setUserAddresses: this.setUserAddresses,
                            setCounty: this.setCounty,
                            setStep: this.setStep,
                            setDentalLicense: this.setDentalLicense,
                            setRegistrationStatus: this.set_registration_status,
                            getRegistrationStatus: this.get_registration_status,
                            registrationLocked: this.registration_locked,
                            resetForm: this.resetForm.bind( this )
                        }}/>
                </div>
        );
    }
}

export default RegistrationContainer;
